import React from 'react';
import { Link } from 'react-router-dom';

/* Components ---------------------------*/
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

/* Logo ---------------------------*/
import logo from './../assets/images/WCPE_logo_color-01.svg';


const Menus = ({showMenuUpdate}) => {

    return (
        <Navbar collapseOnSelect expand="md" bg="light" >
            <Container>
                <Navbar.Brand href="https://www.westerncpe.com">
                <img
                    src={logo}
                    width="150"
                    height="100"
                    className="m-auto"
                    alt="Western CPE LOGO"
                />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link eventKey="home" as={Link} to="/">Home</Nav.Link>
                        <Nav.Link eventKey="federal" as={Link} to="/federal">Federal Tax</Nav.Link>
                        <Nav.Link eventKey="california" as={Link} to="/california">California Tax</Nav.Link>
                        <Nav.Link eventKey="calculator" as={Link} to="/tax-calculator">Tax Calculator</Nav.Link>
                        <Nav.Link eventKey="additional" as={Link} to="/additional">Additional Resources</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Menus;
